// @ts-check
import React, { useState } from "react";

import { QRCodeCanvas } from "qrcode.react";
import Icono from "../ClasesFunsiones/Iconos";
import StudyItem from "../../../models/studies/list";
import { ClientSetting, ContriCodesList } from "../../../Appsettings";
import shareWhatsapp from "../../../utils/shareWhatsapp";
import { SingJWT } from "../../../utils/jwtTools";
import imageQrGenerator from "../../../utils/imageQrGenerator";
import ShareMail from "../../../utils/shareEmail";

/**
 *
 * @typedef {Object} ShareProps
 * @property {function} CerrarDialog
 * @property {Object} activo
 * @property {boolean} activo.visible
 * @property {number} activo.componente
 * @property {StudyItem} paciente
 * @returns
 *
 */

/**
 * @param {ShareProps} props
 * @returns
 */
function Share(props) {
  const [TipoShare, setTipoShare] = useState(0);
  let comp;
  switch (TipoShare) {
    case 1:
      comp = <Mail {...props} />;
      break;
    case 2:
      comp = <QR {...props} />;
      break;
    default:
      comp = <WP {...props} />;
      break;
  }
  /**
   * @param {number} e
   */
  let cambiarshare = (e) => {
    setTipoShare(e);
  };
  return (
    <div className="Share">
      {comp}
      <div className="Selector">
        <BtnShare
          icon="WP"
          onClick={() => {
            cambiarshare(0);
          }}
        />
        <BtnShare
          icon="mail"
          onClick={() => {
            cambiarshare(1);
          }}
        />
        <BtnShare
          icon="QR"
          onClick={() => {
            cambiarshare(2);
          }}
        />
      </div>
    </div>
  );
}

/**
 * @param {Object} props
 * @param {string} props.icon
 * @param {import("react").MouseEventHandler<HTMLDivElement>} props.onClick
 * @returns
 */
const BtnShare = (props) => {
  return (
    <div className="BtnShare" onClick={props.onClick}>
      <div className="iconcont">
        <Icono icon={props.icon} color="white" />
      </div>
    </div>
  );
};

/**
 * @param {ShareProps} props
 * @returns
 */
const WP = (props) => {
  const [WPenvio, setWPenvio] = useState({
    prefijo: ClientSetting.DefaultCountry,
    numero: "",
    tiempo: ClientSetting.sharetime,
    enviando: false,
  });
  /**
   * @param {import("react").ChangeEvent<HTMLSelectElement>} e
   */
  let cambiarprefijo = (e) => {
    setWPenvio({ ...WPenvio, prefijo: e.target.value });
  };
  /**
   * @param {import("react").ChangeEvent<HTMLInputElement>} e
   */
  let cambiarnumero = (e) => {
    setWPenvio({ ...WPenvio, numero: e.target.value });
  };
  /**
   * @param {import("react").ChangeEvent<HTMLInputElement>} e
   */
  let cambiartiempo = (e) => {
    setWPenvio({ ...WPenvio, tiempo: parseInt(e.target.value) });
  };
  /**
   * @returns {void}
   */
  let shareWP = () => {
    setWPenvio({ ...WPenvio, enviando: true });
    const Token = SingJWT(
      {
        ID: props.paciente?.id,
      },
      {
        expiresIn: `${WPenvio.tiempo}h`,
      },
    );
    shareWhatsapp(WPenvio.prefijo + WPenvio.numero, {
      nombre: props.paciente?.getPatientName() || "",
      link: window.location.origin,
      token: Token,
    });
    setTimeout(() => {
      setWPenvio({ ...WPenvio, enviando: false });
    }, 2000);
  };
  return (
    <div className="contenedor">
      <div className="inputdata form-card">
        <h3 className="form-title">Compartir por WhatsApp</h3>
        
        <div className="form-group flex-group">
          <div className="input-wrap select-wrap">
            <select
              className="inputitem"
              value={WPenvio.prefijo}
              onChange={cambiarprefijo}
            >
              {ContriCodesList.map((item, index) => (
                <option key={index} value={item.code}>
                  {item.name}
                </option>
              ))}
            </select>
          </div>
          <div className="input-wrap flex-fill">
            <input
              type="tel"
              className="inputitem"
              placeholder="Número Telefónico"
              value={WPenvio.numero}
              onChange={cambiarnumero}
            />
          </div>
        </div>

        <div className="form-group config-group">
          <span className="Subtitulo">Tiempo de vida:</span>
          <input
            type="number"
            className="inputitem2"
            value={WPenvio.tiempo}
            onChange={cambiartiempo}
            min="1"
          />
          <span className="Subtitulo">Hrs</span>
        </div>

        <div className="Actions">
          <button
            disabled={WPenvio.enviando || WPenvio.numero.length < 8}
            className={WPenvio.enviando ? "BtnAccion loading" : "BtnAccion"}
            onClick={shareWP}
          >
            {WPenvio.enviando ? "Enviando..." : "Enviar Enlace"}
          </button>
        </div>
      </div>
    </div>
  );
};

/**
 * @param {ShareProps} props
 * @returns
 */
const Mail = (props) => {
  console.log(props);
  const [Mailenvio, setMailenvio] = useState({
    direccion: "",
    tiempo: ClientSetting.sharetime,
    enviando: false,
  });
  /**
   * @param {import("react").ChangeEvent<HTMLInputElement>} e
   */
  let cambiardirecion = (e) => {
    setMailenvio({ ...Mailenvio, direccion: e.target.value });
  };
  /**
   * @param {import("react").ChangeEvent<HTMLInputElement>} e
   */
  let cambiartiempo = (e) => {
    setMailenvio({ ...Mailenvio, tiempo: parseInt(e.target.value) });
  };
  let shareMail = async () => {
    setMailenvio({ ...Mailenvio, enviando: true });
    const res = await ShareMail(
      Mailenvio.direccion,
      props.paciente,
      Mailenvio.tiempo,
    );
    if (res) {
      alert("Correo enviado");
      setMailenvio({ ...Mailenvio, enviando: false });
    } else {
      alert("Envio Fallido");
      setMailenvio({ ...Mailenvio, enviando: false });
    }
  };
  return (
    <div className="contenedor">
      <div className="inputdata form-card">
        <h3 className="form-title">Compartir por Correo</h3>
        
        <div className="form-group">
          <div className="input-wrap">
            <input
              type="email"
              className="inputitem"
              placeholder="Correo Electrónico"
              value={Mailenvio.direccion}
              onChange={cambiardirecion}
            />
          </div>
        </div>
        
        <div className="form-group config-group">
          <span className="Subtitulo">Tiempo de vida:</span>
          <input
            type="number"
            className="inputitem2"
            value={Mailenvio.tiempo}
            onChange={cambiartiempo}
            min="1"
          />
          <span className="Subtitulo">Hrs</span>
        </div>
        
        <div className="Actions">
          <button
            disabled={Mailenvio.enviando || !Mailenvio.direccion.includes("@")}
            className={Mailenvio.enviando ? "BtnAccion loading" : "BtnAccion"}
            onClick={shareMail}
          >
            {Mailenvio.enviando ? "Enviando..." : "Enviar Enlace"}
          </button>
        </div>
      </div>
    </div>
  );
};

/**
 * @param {ShareProps} props
 * @returns
 */
const QR = (props) => {
  const study = props.paciente;
  if (!study) {
    return true;
  }
  let url = SingJWT(
    { ID: study.id },
    {
      expiresIn: "48h",
    },
  );
  let longurl = SingJWT({ ID: study.id });
  let copy2 = () => {
    imageQrGenerator(study);
  };
  return (
    <div className="contenedor flex-center">
      <div className="inputdata form-card qr-card">
        <h3 className="form-title">Escanear Código QR</h3>
        <p className="form-subtitle">Validez de 48H</p>
        
        <div className="qr-wrap">
          <QRCodeCanvas value={url} size={220} className="qr-canvas" />
        </div>
        
        <div style={{ display: "none" }} id="QR">
          <QRCodeCanvas value={longurl} size={256} />
        </div>

        <div className="Actions">
          <button className="BtnAccion" onClick={copy2}>
            Copiar Imagen QR
          </button>
        </div>
      </div>
    </div>
  );
};

export default Share;
